<template>
  <div class="home-top-item">
      <div class="home-item-count">
          <div>{{ label }}</div>
          <div>{{ itemCount }}</div>
      </div>
      <img :src="imgPath" />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    itemCount: String,
    imgPath: String,
  },
};
</script>

<style lang='scss' scoped>
    .home-top-item {
        width: 312px;
        height: 130px;
        border-radius: 4px;
        background-color: white;
        padding: 30px 40px 30px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .home-item-count {
            :nth-child(1) {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #000000;
                letter-spacing: 0;
            }
            :nth-child(2) {
                margin-top: 12px;
                font-family: PingFangSC-Regular;
                font-size: 24px;
                color: #000000;
                letter-spacing: 0;

            }
        }
    }
</style>
